import { Types } from "../actions/PMActions";

const initialState = {
    areaList: {},
    isPMUpdated: 0,
    actionResult: {},
    pmOrderById: {},
    pmOrderFiles: [],
    pmAddFiles: [],
    maintenanceType: {},
    pmCreateOrder: {},
    plannedCheckItemGroupListById: {},
    plannedCheckItemsForTask: {},
    isPMCreated: 0,
    pmOrderListPage: {},
};

export const pmReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_AREAS:
            return {
                ...state,
                areaList: action.payload || state.areaList,
            };
        case Types.SET_MAINTENANCE_TYPE:
            return {
                ...state,
                maintenanceType: action.payload || state.maintenanceType,
            };
        case Types.PM_UPDATE_SUCCESS:
            return {
                ...state,
                actionResult: action.payload || state.actionResult,
                isPMUpdated: 1,
            };
        case Types.SET_PM_ORDER_DETAIL_BY_ID:
            return {
                ...state,
                pmOrderById: action.payload.data || state.pmOrderById,
                showDates: action.payload?.showDates,
            };
        case Types.SET_PM_ORDER_DETAIL_BY_ID_NULL:
            return {
                ...state,
                pmOrderById: {},
                showDates: false,
            };
        case Types.PM_UPDATE_ORDER_SUCCESS:
            return {
                ...state,
                pmUpdateOrder: action.payload || state.pmUpdateOrder,
            };
        case Types.PM_UPDATE_ORDER_SUCCESS_AFTER:
            return {
                ...state,
                pmUpdateOrder: {},
            };
        case Types.PM_CREATE_ORDER_SUCCESS:
            return {
                ...state,
                pmCreateOrder: action.payload || state.pmCreateOrder,
                isPMCreated: 1,
            };
        case Types.PM_CREATE_ORDER_SUCCESS_AFTER:
            return {
                ...state,
                pmCreateOrder: {},
                isPMCreated: 0,
            };
        case Types.SET_PM_ORDER_FILES:
            return {
                ...state,
                pmOrderFiles: action.payload || state.pmOrderFiles,
            };
        case Types.POST_PM_ADD_FILES_SUCCESS:
            return {
                ...state,
                pmAddFiles: action.payload || state.pmAddFiles,
            };
        case Types.SET_PM_ORDER_LIST:
            return {
                ...state,
                pmOrderList: action.payload || state.pmOrderList,
            };
        case Types.SET_PM_ORDER_LIST_PAGE:
            return {
                ...state,
                pmOrderListPage: action.payload || state.pmOrderListPage,
            };
        case Types.SET_PLANNED_CHECKITEMGROUPS_BY_ORDERID:
            return {
                ...state,
                plannedCheckItemGroupListById: action.payload || state.plannedCheckItemGroupListById,
            };
        case Types.SET_PLANNED_CHECKITEMS_FOR_TASK:
            return {
                ...state,
                plannedCheckItemsForTask: action.payload || state.plannedCheckItemsForTask,
            };
        case Types.DELETE_PM_ORDER_SUCCESS:
            return {
                ...state,
                isPMOrderDeleted: 1,
                pmOrderDelete: action.payload || state.pmOrderDelete,
            };

        case Types.PM_DELETE_ORDER_SUCCESS_AFTER:
            return {
                ...state,
                pmOrderDelete: {},
                isPMCreated: 0,
            };

        default:
            return state;
    }
};
